<template>
  <v-container class="allibo-joblist-container" v-if="job">
    <v-row class="allibo-job-wrapper">
      <v-col cols="12" md="7">
        <h2>{{ job.title }}</h2>
        <div v-for="content in job.details.contents" :key="content.id">
          <h3>{{ content.title }}</h3>
          <div v-html="content.value"></div>
        </div>
      </v-col>
      <v-col cols="12" md="5">
        <div class="ticket-form-container grey lighten-3 pa-3 rounded">
          <v-form
            ref="formRef"
            v-model="valid"
            lazy-validation
            @submit.prevent.stop="handleSubmit"
          >
            <h2>Invia il tuo CV</h2>

            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="candidate.firstName"
                  label="Nome"
                  :id="'id_' + Math.random()"
                  dense
                  background-color="white"
                  outlined
                  required
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="candidate.lastName"
                  label="Cognome"
                  :id="'id_' + Math.random()"
                  dense
                  background-color="white"
                  outlined
                  required
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="candidate.email"
                  label="E-mail"
                  :id="'id_' + Math.random()"
                  dense
                  background-color="white"
                  outlined
                  required
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-file-input
                  outlined
                  background-color="white"
                  dense
                  v-model="attachmentModel"
                  accept="application/pdf,.doc,.docx"
                  label="File CV"
                  required
                ></v-file-input>
              </v-col>
              <!-- <v-col cols="12">
                <div class="d-flex align-center job-privacy">
                  <PrivacyLinks></PrivacyLinks>
                </div>
              </v-col> -->
            </v-row>
            <v-alert type="error" v-if="imgErrorString">{{
              $t("tickets.imgTooBigError")
            }}</v-alert>
            <div
              class="buttons-container mt-10 d-flex flex-column flex-sm-row justify-center"
            >
              <v-btn
                depressed
                large
                color="primary"
                type="submit"
                min-width="250"
                :disabled="disableSubmit"
                >{{ $t("ticket.confirmBtn") }}</v-btn
              >
            </div>
          </v-form>
        </div>
      </v-col>
    </v-row>
  </v-container>
  <!-- <v-container v-else>Non ci sono jobs!</v-container> -->
</template>
<style scoped lang="scss">
::v-deep .allibo-filters .v-input__slot {
  background: rgba(49, 46, 129, 0.2) !important;
}
.allibo-filters {
  margin-bottom: 16px;
}
.allibo-job {
  display: block;
  padding: 16px;
  border: 1px $primary solid;
  border-radius: 16px;
  box-shadow: 0 0 4px 1px $primary;
  // margin-bottom: 16px;
  text-decoration: none;
  font-weight: bold;
}
</style>
<script>
import axios from "~/plugins/axios";
// import PrivacyLinks from "@/components/navigation/PrivacyLinks.vue";

// import get from "lodash/get";
export default {
  data() {
    return {
      job: null,
      candidate: {},
      attachmentModel: null,
      imgErrorString: false
    };
  },
  computed: {
    // formattedDescription() {
    //   return this.job.description.replace(/\n/g, "<br>");
    // },
    disableSubmit() {
      return (
        !this.candidate.firstName ||
        !this.candidate.lastName ||
        !this.candidate.email ||
        !this.attachmentModel
      );
    }
  },
  methods: {
    async toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    async handleSubmit(e) {
      var _this = this;
      console.log(_this);
      e.preventDefault();

      //file deve essere minore di 2mb
      if (_this.attachmentModel && _this.attachmentModel.size / 1024 > 5120) {
        _this.imgErrorString = true;
      } else {
        _this.imgErrorString = false;

        if (_this.attachmentModel) {
          _this.attachmentModel.cvBase64 = await _this.toBase64(
            _this.attachmentModel
          );
        }
      }
      let url =
        "https://europe-west1-steps-c4a79.cloudfunctions.net/api/applies";

      const requestBody = {
        candidate: this.candidate,
        jobPostId: this.jobId,
        cvBase64: this.attachmentModel.cvBase64,
        cvFilename: this.attachmentModel.name
      };

      return axios
        .post(url, requestBody, {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.VUE_APP_STEPSCONNECT_KEY
          }
        })
        .then(response => {
          if (response.status === 200 || response.status === 201) {
            //             global.EventBus.$emit("success", {
            //   message: global.EventBus.$t("workWithUs.formSubmitted")
            // });
            _this.$refs.formRef.reset(); // reset form
            _this.$router.push({ name: "JobThankYouPage" });
          }
        })
        .catch(error => {
          console.error("Errore nell'invio della candidatura:", error);
          global.EventBus.$emit("error", {
            message: global.EventBus.$t("workWithUs.formSubmittedError")
          });
        });
    },
    async fetchJob(jobId) {
      let url = `https://europe-west1-steps-c4a79.cloudfunctions.net/api/job-posts/${jobId}`;
      return axios
        .get(url, {
          headers: {
            accept: "application/json",
            "x-api-key": process.env.VUE_APP_STEPSCONNECT_KEY
          }
        })
        .then(response => {
          return response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    shareOnWA() {
      //let share = this.createStringList(true);
      // let share = encodeURIComponent(this.createStringList(true).join("\n\n"));
      let share = encodeURIComponent(this.createStringList(true).join("\r\n"));
      // window.location.href = `https://api.whatsapp.com/send?text=${share}`;
      if (this.$platform_is_cordova) {
        window.cordova.InAppBrowser.open(
          "https://api.whatsapp.com/send/?phone&text=" + share,
          "_system"
        );
      } else {
        if (
          /android|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          window.open(
            "https://api.whatsapp.com/send/?phone&text=" + share,
            "_blank"
          );
        } else {
          window.open(
            "https://web.whatsapp.com/send/?phone&text=" + share,
            "_blank"
          );
        }
      }
    },
    shareOnEmail() {
      let share = encodeURIComponent(this.createStringList().join("\n\n"));
      window.location = `mailto:?subject=GUARDA QUESTO ANNUNCIO DI LAVORO: ${this.JOB.title} &body=${share}`;
    }
  },
  async created() {
    this.jobId = this.$route.params.jobId;
    this.job = await this.fetchJob(this.jobId);
  }
};
</script>
